export const routes = (prefix = `admissions`) => [
    {
        path: `/${prefix}/gate-pass/:patientID/:dateAdmitted`,
        name: `${prefix}.gate-pass.print`,
        component: () => import('./PrintGatePass.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharged-patients.index`,
                PageDescription: "Admissions - Discharged patients",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/discharge-summary`,
        name: `${prefix}.discharge-summary.print`,
        component: () => import('./DischargeSummary.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharged-patients.index`,
                PageDescription: "Admissions - Discharged patients",
            },
            print: true,
        },
    },
    {
        path: `/${prefix}/discharge-patient-bill`,
        name: `${prefix}.discharge-patient-bill.print`,
        component: () => import('./PatientBill.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharged-patients.index`,
                PageDescription: "Admissions - Discharged patients",
            },
            print: true,
        },
    },
];
